import {
    Button,
    Command,
    CommandEmpty,
    CommandGroup,
    CommandInput,
    CommandItem,
    CommandList,
    Popover,
    PopoverContent,
    PopoverTrigger,
    Skeleton,
} from '@repo/shadcn';
import { ChevronsUpDown } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useController } from 'react-hook-form';

import { useGetStrengthQuery } from '../../../../../features/slice/products/strength/strength-api-slice';

export function StrengthAutoComplete({ control, name }: any) {
    const [open, setOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm]);

    const { data: searchData, isLoading } = useGetStrengthQuery({
        limit: 10,
        page: 1,
        search: debouncedSearchTerm || undefined,
        sort_order: 'asc',
    });

    const handleSearchInput = (value: string) => {
        setSearchTerm(value);
    };

    const { field } = useController({ name, control });

    const selectedStrength = searchData?.data.find(
        (strength: any) => strength.id === field.value,
    );

    if (isLoading) {
        return <Skeleton className="mt-2 h-[40px] w-full" />;
    }

    return (
        <div id="portal-root">
            <Popover open={open} onOpenChange={setOpen}>
                <PopoverTrigger asChild>
                    <Button
                        variant="outline"
                        role="combobox"
                        aria-expanded={open}
                        className="w-full justify-between   truncate"
                    >
                        <p className="w-[90%] truncate duration-300">
                            {selectedStrength
                                ? selectedStrength.name
                                : 'Select strength...'}
                        </p>
                        <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                    </Button>
                </PopoverTrigger>
                <PopoverContent>
                    <Command className="relative w-[300px]">
                        <CommandInput
                            value={searchTerm}
                            onValueChange={handleSearchInput}
                            placeholder="Search strength..."
                            className="truncate"
                        />
                        <CommandList>
                            <CommandEmpty>No strength found.</CommandEmpty>
                            <CommandGroup>
                                {searchData?.data?.map((strength: any) => (
                                    <CommandItem
                                        key={strength.id}
                                        value={strength.name}
                                        onSelect={() => {
                                            field.onChange(strength.id);
                                            setOpen(false);
                                        }}
                                        className="border-b-[1px]"
                                    >
                                        {strength.name}
                                    </CommandItem>
                                ))}
                            </CommandGroup>
                        </CommandList>
                    </Command>
                </PopoverContent>
            </Popover>
        </div>
    );
}
